var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMainCheck = function SvgMainCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#5049E5",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.47 4.53c.26.26.26.68 0 .94l-5.5 5.5c-.26.26-.68.26-.94 0l-2.5-2.5a.665.665 0 0 1 .94-.94L6.5 9.56l5.03-5.03c.26-.26.68-.26.94 0",
    clipRule: "evenodd"
  })));
};
export default SvgMainCheck;